(function () {
  'use strict';

  const STORAGE_KEY = 'muralls:wall-size:v1';
  const CM_PER_INCH = 2.54;
  function readStored() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!value || !(value.widthCm > 0) || !(value.heightCm > 0)) return null;
      return value;
    } catch (_) {
      return null;
    }
  }

  function save(widthCm, heightCm, unit) {
    if (!(widthCm > 0) || !(heightCm > 0)) return;
    const value = {
      widthCm: Math.round(widthCm * 1000) / 1000,
      heightCm: Math.round(heightCm * 1000) / 1000,
      unit: unit || 'cm',
      updatedAt: Date.now()
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      window.dispatchEvent(new CustomEvent('muralls:wall-size-change', { detail: value }));
    } catch (_) {}
  }

  function displaySize(value) {
    if (!value) return '';
    if (value.unit === 'cm') {
      return `${Math.round(value.widthCm)} × ${Math.round(value.heightCm)} cm`;
    }
    const widthIn = value.widthCm / CM_PER_INCH;
    const heightIn = value.heightCm / CM_PER_INCH;
    if (value.unit === 'ftin') {
      const ftIn = (inches) => `${Math.floor(inches / 12)}′${Math.round(inches % 12)}″`;
      return `${ftIn(widthIn)} × ${ftIn(heightIn)}`;
    }
    return `${Math.round(widthIn)} × ${Math.round(heightIn)} in`;
  }

  function setValue(root, selector, value) {
    const input = root.querySelector(selector);
    if (!input) return;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function addRestoredNote(target, value) {
    if (!target || target.querySelector('.wall-size-memory-note')) return;
    const note = document.createElement('span');
    note.className = 'wall-size-memory-note';
    note.textContent = `Saved wall restored: ${displaySize(value)}`;
    target.appendChild(note);
  }

  function initMuralCta(root) {
    const inputs = root.querySelectorAll('[data-mural-input]');
    if (!inputs.length) return;

    const stored = readStored();
    if (stored) {
      const preferred = root.querySelector(`[data-mural-unit="${stored.unit}"]`)
        || root.querySelector('[data-mural-unit="in"]')
        || root.querySelector('[data-mural-unit="cm"]');
      if (preferred) preferred.click();
      const active = root.querySelector('[data-mural-unit].is-selected');
      const unit = active ? active.dataset.muralUnit : 'cm';
      if (unit === 'cm') {
        setValue(root, '[data-dim="w_cm"]', Math.round(stored.widthCm));
        setValue(root, '[data-dim="h_cm"]', Math.round(stored.heightCm));
      } else if (unit === 'in') {
        setValue(root, '[data-dim="w_in_only"]', Math.round(stored.widthCm / CM_PER_INCH));
        setValue(root, '[data-dim="h_in_only"]', Math.round(stored.heightCm / CM_PER_INCH));
      } else {
        const widthIn = stored.widthCm / CM_PER_INCH;
        const heightIn = stored.heightCm / CM_PER_INCH;
        setValue(root, '[data-dim="w_ft"]', Math.floor(widthIn / 12));
        setValue(root, '[data-dim="w_in"]', Math.round(widthIn % 12));
        setValue(root, '[data-dim="h_ft"]', Math.floor(heightIn / 12));
        setValue(root, '[data-dim="h_in"]', Math.round(heightIn % 12));
      }
      addRestoredNote(root.querySelector('.mural-cta-card__size'), stored);
    }

    function capture() {
      const active = root.querySelector('[data-mural-unit].is-selected');
      const unit = active ? active.dataset.muralUnit : 'cm';
      const num = (name) => parseFloat(root.querySelector(`[data-dim="${name}"]`)?.value) || 0;
      let widthCm = 0;
      let heightCm = 0;
      if (unit === 'cm') {
        widthCm = num('w_cm'); heightCm = num('h_cm');
      } else if (unit === 'in') {
        widthCm = num('w_in_only') * CM_PER_INCH; heightCm = num('h_in_only') * CM_PER_INCH;
      } else {
        widthCm = (num('w_ft') * 12 + num('w_in')) * CM_PER_INCH;
        heightCm = (num('h_ft') * 12 + num('h_in')) * CM_PER_INCH;
      }
      save(widthCm, heightCm, unit);
    }
    inputs.forEach((input) => input.addEventListener('input', capture));
  }

  function initCustomizer(root) {
    const stored = readStored();
    const hasUrlSize = new URLSearchParams(location.search).has('w_cm');
    if (stored && !hasUrlSize) {
      const unitBtn = root.querySelector(`[data-unit="${stored.unit}"]`) || root.querySelector('[data-unit="in"]');
      if (unitBtn) unitBtn.click();
      const unit = root.querySelector('[data-unit].is-active')?.dataset.unit || 'cm';
      if (unit === 'cm') {
        setValue(root, '[data-dim="w_cm"]', Math.round(stored.widthCm));
        setValue(root, '[data-dim="h_cm"]', Math.round(stored.heightCm));
      } else if (unit === 'in') {
        setValue(root, '[data-dim="w_in_only"]', Math.round(stored.widthCm / CM_PER_INCH));
        setValue(root, '[data-dim="h_in_only"]', Math.round(stored.heightCm / CM_PER_INCH));
      } else {
        const widthIn = stored.widthCm / CM_PER_INCH;
        const heightIn = stored.heightCm / CM_PER_INCH;
        setValue(root, '[data-dim="w_ft"]', Math.floor(widthIn / 12));
        setValue(root, '[data-dim="w_in"]', Math.round(widthIn % 12));
        setValue(root, '[data-dim="h_ft"]', Math.floor(heightIn / 12));
        setValue(root, '[data-dim="h_in"]', Math.round(heightIn % 12));
      }
      addRestoredNote(root.querySelector('.customizer__card-header'), stored);
    }

    function capture() {
      const unit = root.querySelector('[data-unit].is-active')?.dataset.unit || 'cm';
      const num = (name) => parseFloat(root.querySelector(`[data-dim="${name}"]`)?.value) || 0;
      let widthCm = 0;
      let heightCm = 0;
      if (unit === 'cm') {
        widthCm = num('w_cm'); heightCm = num('h_cm');
      } else if (unit === 'in') {
        widthCm = num('w_in_only') * CM_PER_INCH; heightCm = num('h_in_only') * CM_PER_INCH;
      } else {
        widthCm = (num('w_ft') * 12 + num('w_in')) * CM_PER_INCH;
        heightCm = (num('h_ft') * 12 + num('h_in')) * CM_PER_INCH;
      }
      save(widthCm, heightCm, unit);
    }
    root.querySelectorAll('[data-dim]').forEach((input) => input.addEventListener('input', capture));
  }

  function initRollCalculator(modal) {
    const stored = readStored();
    const trigger = document.querySelector('[data-calc-open]');
    if (stored && trigger) {
      const savedWall = displaySize(stored);
      if (trigger.closest('.wp-cta-card')) {
        trigger.lastChild.textContent = ' Saved wall · Calculate rolls →';
        trigger.title = `Saved wall: ${savedWall}`;
        trigger.setAttribute('aria-label', `Calculate rolls for saved wall: ${savedWall}`);
      } else {
        trigger.lastChild.textContent = ` Your saved wall: ${savedWall} · Calculate rolls →`;
      }
    }
    if (stored) {
      const unit = stored.unit === 'cm' ? 'cm' : 'in';
      modal.querySelector(`[data-rc-unit="${unit}"]`)?.click();
      setValue(modal, '[data-rc-width]', unit === 'cm' ? Math.round(stored.widthCm) : Math.round(stored.widthCm / CM_PER_INCH));
      setValue(modal, '[data-rc-height]', unit === 'cm' ? Math.round(stored.heightCm) : Math.round(stored.heightCm / CM_PER_INCH));
    }

    const capture = () => {
      const active = modal.querySelector('[data-rc-unit].is-active')?.dataset.rcUnit || 'in';
      const width = parseFloat(modal.querySelector('[data-rc-width]')?.value) || 0;
      const height = parseFloat(modal.querySelector('[data-rc-height]')?.value) || 0;
      save(active === 'cm' ? width : width * CM_PER_INCH, active === 'cm' ? height : height * CM_PER_INCH, active);
    };
    modal.querySelector('[data-rc-width]')?.addEventListener('input', capture);
    modal.querySelector('[data-rc-height]')?.addEventListener('input', capture);
  }

  function init() {
    document.querySelectorAll('.mural-cta-card').forEach(initMuralCta);
    document.querySelectorAll('[data-mural-customizer]').forEach(initCustomizer);
    document.querySelectorAll('[data-rc-root]').forEach(initRollCalculator);
  }

  window.MurallsWallSize = { get: readStored, save, clear: () => localStorage.removeItem(STORAGE_KEY) };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
